import axios from 'axios'
import baseUrl from '../config.json'

export const passwordreset = (id,data)=>{
    return axios.put(baseUrl.apiEndPoint+"/api/passwordreset/"+id,data)
}

const api={
    passwordreset
}
export default api